import React from 'react';

import { LinkProps } from '@soluto-design/link';

import { Title, Text, Button, Icon } from '@soluto-design/react';

import CardBase from '../CardBase';
import cls from '@soluto-design/styles/cls';

export interface CardNavigationTextProps {
    cta?: LinkProps;
    title?: string;
    text?: string;
}

export default function CardNavigationText({
    cta,
    title,
    text,
}: CardNavigationTextProps) {
    return (
        <>
            <CardBase
                href={cta?.href}
                className={cls(
                    'overflow-hidden rounded-large p-lg bg-background-brand-primary',
                    cta?.disabled && 'bg-background-disabled',
                )}>
                {title && (
                    <Title
                        component="p"
                        className={cls(
                            'flex flex-col gap-xs text-h300 text-text-static',
                            cta?.disabled && 'text-text-disabled',
                        )}>
                        {title}
                    </Title>
                )}
                {text && (
                    <Text
                        isHtml
                        component="p"
                        className={cls(
                            'pt-sm text-b400 text-text-static',
                            cta?.disabled && 'text-text-disabled',
                        )}>
                        {text}
                    </Text>
                )}
                {cta && (
                    <Button
                        disabled={cta.disabled}
                        variant="tertiary"
                        className={cls(
                            'hidden md:inline-flex mt-xg !min-w-32',
                            cta.children && ' group relative px-8 hover:px-16',
                        )}
                        size={cta.children ? 'medium' : 'icon'}
                        href={cta.href}
                        tabIndex={-1}
                        leftIcon={
                            !cta.children && 'arrow-direction--type-right'
                        }>
                        {cta.children && (
                            <>
                                <span
                                    className={cls(
                                        'absolute hidden right-[100%] group-hover:relative group-hover:block group-hover:right-0 transition ease-in-out duration-800',
                                    )}>
                                    {cta.children}
                                </span>

                                <Icon icon="arrow-direction--type-right" />
                            </>
                        )}
                    </Button>
                )}
                {cta && (
                    <Button
                        disabled={cta.disabled}
                        variant="tertiary"
                        className="mt-xg md:hidden"
                        rightIcon="arrow-direction--type-right"
                        size={cta.children ? 'medium' : 'icon'}
                        href={cta.href}
                        tabIndex={-1}>
                        {cta?.children || null}
                    </Button>
                )}
            </CardBase>
        </>
    );
}
